import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PromoAlertComponent } from './promo-alert.component';

@NgModule({
  declarations: [PromoAlertComponent],
  imports: [CommonModule],
  exports: [PromoAlertComponent],
})
export class PromoAlertModule {}
